import { useState } from 'react';

interface MobileTapBehavior {
	isPressed: boolean;
	touchHandlers: {
		onTouchStart?: () => void;
		onTouchEnd?: () => void;
		onTouchMove?: () => void;
		onTouchCancel?: () => void;
	};
}

export const useMobileTapBehavior = (isMobile: boolean): MobileTapBehavior => {
	const [isPressed, setIsPressed] = useState(false);

	const handleTouchStart = () => {
		setIsPressed(true);
	};

	const handleTouchEnd = () => {
		setIsPressed(false);
	};

	const handleTouchMove = () => {
		// Cancel the pressed state when scrolling starts
		if (isPressed) {
			setIsPressed(false);
		}
	};

	return {
		isPressed,
		touchHandlers: isMobile
			? {
					onTouchStart: handleTouchStart,
					onTouchEnd: handleTouchEnd,
					onTouchMove: handleTouchMove,
					onTouchCancel: handleTouchEnd,
			  }
			: {},
	};
};
